import React from 'react';
import { Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../contexts/JWTAuthContext';

const RoleProtectedRoute = ({ children, allowedRoles = ['admin'] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return (
      <div className="access-denied-page">
        <motion.div 
          className="access-denied glass-effect"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
        >
          <AlertTriangle size={48} className="access-icon" />
          <h2>Access Denied</h2>
          <p>You don't have permission to access this page.</p>
          <p className="role-info">Required role: {allowedRoles.join(' or ')}</p>
          <p className="current-role">Your role: {user.role}</p>
        </motion.div>
      </div>
    );
  }

  return children;
};

export default RoleProtectedRoute;
